import React from "react";
import PropTypes from "prop-types";

class PlayerPortal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { onClick } = this.props;
    onClick(this.props.object);
  }

  render() {
    const divStyle = {
      position: "absolute",
      top: "0",
      left: "0",
      width: (parseFloat(this.props.object.size) || 200) + "px",
      height: (parseFloat(this.props.object.size) || 200) + "px",
      WebkitTransform: "translate(-50%, -50%)",
      MozTransform: "translate(-50%, -50%)",
      OTransform: "translate(-50%, -50%)",
      transform: "translate(-50%, -50%)",
      cursor: "pointer",
      border:
        "solid " +
        (parseFloat(this.props.object.size) || 200) * 0.15 +
        "px rgba(255, 255, 255, 0.75)",
      borderRadius: "50%",
      boxSizing: "border-box",
      // boxShadow: "0 0 10px rgba(0, 0, 0, 0.75)"
      filter:
        "drop-shadow(0 0 " +
        (parseFloat(this.props.object.size) || 200) * 0.1 +
        "px rgba(0, 0, 0, 0.75))"
    };
    return (
      <div
        className="PlayerPortal"
        style={this.props.style ? this.props.style : divStyle}
        onClick={this.onClick}
        onTouchStart={this.onClick}
      />
    );
  }
}

PlayerPortal.propTypes = {
  onClick: PropTypes.func
};

export default PlayerPortal;



// WEBPACK FOOTER //
// ./src/components/Player/PlayerPortal/PlayerPortal.js